//
//
//
//
//
//
//
//
//

import ConfirmDialog from 'ui-kit/src/components/ConfirmDialog';
import EditInput from '@/components/edit/EditInput';

export default {
    extends: EditInput,

    watch: {
        editItem() {
            // TODO: Reset (if needed?)
        },
    },

    methods: {
        addFiles(files) {
            this.$refs.uploader.addFiles(files);
        },
        safeRemoveFn(file) {
            this.$q.dialog({
                component: ConfirmDialog,
                title: this.$t(`confirm.remove.title.files`),
                message: this.$t(`confirm.remove.message.files.${this.collName}`),
                okLabel: 'Smazat',
                cancelLabel: 'Storno',
            }).onOk(() => {
                $.set(file, 'removed', true);
            });
        },
    },
};
